// See docs/dop-staff-access-contract.md. The API must resolve all role=3
// assignments; other portals never grant DOP access.
export const portalAccess = (user) => {
  const role = user?.roles?.DeliveryOperationsPortal;
  const id = String(user?.id ?? '');
  const ready = /^[1-9]\d*$/.test(id) && Number.isSafeInteger(Number(id));
  return {
    ready,
    id: ready ? id : null,
    dispatcher: ready && ['Admin', 'LocalAreaManager', 'RegionalAreaManager'].includes(role),
    // Driver-only support is disabled until an authoritative native identity
    // contract exists. Account IDs must never be used as driver identities.
    driver: false,
  };
};

export const portalLanding = () => {
  return '/';
};
